// Angular Imports
import { NgModule } from '@angular/core';
import { WaypointService } from './waypoint.service';

@NgModule({
  imports: [],
  providers: [WaypointService],
})
export class WaypointModule {}
